import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { workareaBaseQuery } from './workArearBaseQuery';
import { CodelistResponce } from 'src/types/URLKeys';

export const workareaApi = createApi({
  baseQuery: workareaBaseQuery,
  reducerPath: 'workareaApi',
  endpoints: builder => ({
    getTickets: builder.query<any, void>({
      query: () => ({
        url: formatString(endPoints.ticket.list),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createTicket: builder.mutation<any, any>({
      query: ({ data, study_id, site_id, country }) => ({
        url: `${formatString(
          endPoints.ticket.create
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=CTMS`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getSysAdminCodelist: builder.query<any, string>({
      query: code_list_code => ({
        url: formatString(endPoints.CodeList.select, {
          key: urlKeys.code_list_code,
          value: code_list_code
        }),
        extraOptions: { maxRetries: 3 }
      }),
      transformResponse: (response: CodelistResponce) => response?.selected_data ?? []
    }),
    getSysAdminNewCodelist: builder.query<any, string>({
      query: code_list_code => ({
        url: formatString(endPoints.CodeList.newSelect, {
          key: urlKeys.code_list_code,
          value: code_list_code
        }),
        method: 'POST',
        extraOptions: { maxRetries: 3 }
      }),
      transformResponse: (response: CodelistResponce) => response?.selected_data ?? []
    }),
    getPersonnelTicket: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.ticket.getPersonelTicket
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=CTMS`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
      //transformResponse: (response: { data: any }) => response.data
    }),
    getKeycloakGroups: builder.query<any, void>({
      query: () => ({
        url: formatString(endPoints.sysAdmin.groups),
        method: 'GET'
      })
    }),
    getCodelistValueCodeAPI: builder.query<any, any>({
      query: ({ code_list_code, application, application_section }) => ({
        url: `${formatString(endPoints.codeListValueCode.read, {
          key: 'code_list_code',
          value: code_list_code
        })}?application=${application}&application_section=${application_section}`,
        method: 'POST'
      }),
      transformResponse: (response: CodelistResponce) => response?.selected_data ?? []
    }),
    getSponsorLogo: builder.query<any, any>({
      query: () => ({
        url: `${formatString(
          endPoints.reportConfiguration.select
        )}?application=SYSADMIN&application_module_section=${'CONFIGURATION'}`,
        method: 'GET'
      })
    }),
    getLatestSubjectID: builder.mutation<any, any>({
      query: ({ study_id, country, site_id }) => {
        return ({
        url: `${formatString(
          endPoints.getLatestSubjectId.select,
          {
            key: urlKeys.study_id,
            value: study_id
          }
        )}?type=SUBJECT&application=TSDA&application_section=CONDUCT`,
        method: 'GET'
      })
    }
    }),

    getPharmacyList: builder.mutation<any, any>({
      query: ({ study_id, site_id, application }) => {
        return ({
        url: `${formatString(
          endPoints.sysAdmin.selectPharmacy,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          { key: urlKeys.site_id, value: site_id },
        )}?application=${application}`,
        method: 'GET'
      })
    }
    })
  })
});

export const {
  useGetTicketsQuery,
  useCreateTicketMutation,
  useGetSysAdminCodelistQuery,
  useGetSysAdminNewCodelistQuery,
  useLazyGetSysAdminNewCodelistQuery,
  useGetPersonnelTicketMutation,
  useGetKeycloakGroupsQuery,
  useGetCodelistValueCodeAPIQuery,
  useLazyGetSponsorLogoQuery,
  useGetLatestSubjectIDMutation,
  useGetPharmacyListMutation
} = workareaApi;
